// Quick date-range presets for <input type="date"> filters (local YYYY-MM-DD strings).

export const DATE_RANGE_PRESETS = [
  { id: 'last7', label: 'Last 7 days' },
  { id: 'thisMonth', label: 'This month' },
  { id: 'last30', label: 'Last 30 days' },
  { id: 'all', label: 'All time' },
];

export function toDateInputValue(date) {
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
}

const daysAgo = (now, days) => new Date(now.getFullYear(), now.getMonth(), now.getDate() - days);

/** `{ from, to }` for a preset id, relative to `now` (inclusive of today). Unknown ids return null. */
export function getDateRangePreset(id, now = new Date()) {
  const today = toDateInputValue(now);
  switch (id) {
    case 'last7':
      return { from: toDateInputValue(daysAgo(now, 6)), to: today };
    case 'last30':
      return { from: toDateInputValue(daysAgo(now, 29)), to: today };
    case 'thisMonth':
      return { from: toDateInputValue(new Date(now.getFullYear(), now.getMonth(), 1)), to: today };
    case 'all':
      return { from: '', to: '' };
    default:
      return null;
  }
}

/** Rolling presets are re-applied on load so a saved "Last 7 days" keeps meaning the last 7 days. */
export function isRollingDatePreset(id) {
  return id === 'last7' || id === 'last30' || id === 'thisMonth';
}
